import firebase from "../../firebase";
export function getNumberGamesPs4(){
    let docRef = firebase.db.collection("ps4");
    return docRef.get().then(res => {
        return res.size;
    })
}

export function getNumberGamesPs5(){
    let docRef = firebase.db.collection("ps5");
    return docRef.get().then(res => {
        return res.size;
    })
}

export function getNumberGamesSwitch(){
    let docRef = firebase.db.collection("switch");
    return docRef.get().then(res => {
        return res.size;
    })
}

export async function getGamesPs4(){
    let docRef = await firebase.db.collection("ps4").get();
    return docRef.docs.map(doc => doc.data());   
}
export async function getGamesPs4Offer(){
    let docRef = await firebase.db.collection("ps4").where("offer", "==", "yes").get();
        return docRef.docs.map(doc => doc.data());
}

export async function getGamesStock(){
    let docRef = await firebase.db.collection("ps4").where("stock", "==", "yes").get();
        return docRef.docs.map(doc => doc.data());
}